export default "__VITE_ASSET__N5Eyi4PL__"